import { render, staticRenderFns } from "./ResultSplash.vue?vue&type=template&id=3411499e&"
import script from "./ResultSplash.vue?vue&type=script&lang=js&"
export * from "./ResultSplash.vue?vue&type=script&lang=js&"
import style0 from "./ResultSplash.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports